module.exports = __webpack_public_path__ + "static/img/shareicon.ffe285d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shareicon.png
// module id = FW2X
// module chunks = 18